
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as _91slug_93O1a1gRcYZnMeta } from "/src/pages/(section-models)/products-listing/[slug].vue?macro=true";
import { default as _91slug_93K3jKkEP2T3Meta } from "/src/pages/(section-models)/ribbon/[slug].vue?macro=true";
import { default as _91slug_932d9Lb8F5D4Meta } from "/src/pages/(section-models)/symbol/[slug].vue?macro=true";
import { default as _91_46_46_46slug_93ly9c2K2HsSMeta } from "/src/pages/[...slug].vue?macro=true";
import { default as c_91id_939lfc6Lx5DfMeta } from "/src/pages/[slug]/[childSlug]/c[id].vue?macro=true";
import { default as c_91id_93rfOdXDR9I1Meta } from "/src/pages/[slug]/c[id].vue?macro=true";
import { default as p_91id_93sbrrAKGVMKMeta } from "/src/pages/[slug]/p[id].vue?macro=true";
import { default as addressesIGZCkwNaoqMeta } from "/src/pages/account/addresses.vue?macro=true";
import { default as branchLeelI7jTJ2Meta } from "/src/pages/account/branch.vue?macro=true";
import { default as homewOlFek1DsrMeta } from "/src/pages/account/home.vue?macro=true";
import { default as indexooyXi1B20PMeta } from "/src/pages/account/message/index.vue?macro=true";
import { default as order_45againAl94P4iRtrMeta } from "/src/pages/account/order-again.vue?macro=true";
import { default as indexU0lkcgg280Meta } from "/src/pages/account/order-history/index.vue?macro=true";
import { default as _91slug_93iFCusQg9rAMeta } from "/src/pages/account/order-history/product-review/[slug].vue?macro=true";
import { default as preferencesdJ2KFlTg2IMeta } from "/src/pages/account/preferences.vue?macro=true";
import { default as credit_45limitU3cA6y74U5Meta } from "/src/pages/account/pro-card/credit-limit.vue?macro=true";
import { default as indexNPNSvaNcoVMeta } from "/src/pages/account/pro-card/index.vue?macro=true";
import { default as ordersszUGksC2AFMeta } from "/src/pages/account/pro-card/orders.vue?macro=true";
import { default as profile4xkbZgafKZMeta } from "/src/pages/account/profile.vue?macro=true";
import { default as saved_45listszdd9554BNSMeta } from "/src/pages/account/saved-lists.vue?macro=true";
import { default as stock_45notificationXbeAeLQuTaMeta } from "/src/pages/account/stock-notification.vue?macro=true";
import { default as _91_46_46_46slug_93xLhZ1hBRygMeta } from "/src/pages/advices/[...slug].vue?macro=true";
import { default as indexEyxyPGnrbHMeta } from "/src/pages/advices/index.vue?macro=true";
import { default as _91_46_46_46slug_93EY5SSVRI6YMeta } from "/src/pages/advices/search/[...slug].vue?macro=true";
import { default as indexHRVmEEvxAKMeta } from "/src/pages/blogs-news-advices/index.vue?macro=true";
import { default as _91_46_46_46slug_937g10I74Z2JMeta } from "/src/pages/blogs/[...slug].vue?macro=true";
import { default as indexLGTLYt44r4Meta } from "/src/pages/blogs/index.vue?macro=true";
import { default as _91_46_46_46slug_93rxDafmwWPgMeta } from "/src/pages/blogs/search/[...slug].vue?macro=true";
import { default as _91slug_93DTPZFeXt6DMeta } from "/src/pages/branches/[slug].vue?macro=true";
import { default as indexr2YxwZqgCOMeta } from "/src/pages/branches/index.vue?macro=true";
import { default as indexTs0s2nd2ddMeta } from "/src/pages/buy-now/index.vue?macro=true";
import { default as indexoXXbidaoKtMeta } from "/src/pages/categories/index.vue?macro=true";
import { default as fallbackxkdwHKBZ1gMeta } from "/src/pages/checkout/fallback.vue?macro=true";
import { default as index4E3N5yzW7cMeta } from "/src/pages/checkout/index.vue?macro=true";
import { default as _91slug_93fTREvo4l4pMeta } from "/src/pages/checkout/order-confirmation/[slug].vue?macro=true";
import { default as _91_46_46_46slug_93cyGcYUJqP3Meta } from "/src/pages/content/[...slug].vue?macro=true";
import { default as _91_46_46_46slug_93c99CfJteH1Meta } from "/src/pages/events/[...slug].vue?macro=true";
import { default as indexOcliQTazEQMeta } from "/src/pages/events/index.vue?macro=true";
import { default as _91_46_46_46slug_932yJBSwxW79Meta } from "/src/pages/events/offline/[...slug].vue?macro=true";
import { default as indexkhW7kTjsaRMeta } from "/src/pages/events/offline/index.vue?macro=true";
import { default as _91_46_46_46slug_93qNabIEySkrMeta } from "/src/pages/events/online/[...slug].vue?macro=true";
import { default as indexwvyP84xKKdMeta } from "/src/pages/events/online/index.vue?macro=true";
import { default as indexvsa0KwJWqiMeta } from "/src/pages/index.vue?macro=true";
import { default as loginTLBFe6DICLMeta } from "/src/pages/login.vue?macro=true";
import { default as dealso75S7JgVGcMeta } from "/src/pages/merk/[brandName]/deals.vue?macro=true";
import { default as indexyGz7q34VsOMeta } from "/src/pages/merk/[brandName]/index.vue?macro=true";
import { default as productsD4rnmw1ybqMeta } from "/src/pages/merk/[brandName]/products.vue?macro=true";
import { default as indexu024RY7F5aMeta } from "/src/pages/merk/index.vue?macro=true";
import { default as _91_46_46_46slug_931HLusbMFb3Meta } from "/src/pages/news/[...slug].vue?macro=true";
import { default as indexzgwfkR7kquMeta } from "/src/pages/news/index.vue?macro=true";
import { default as _91_46_46_46slug_93HClrgBO4fiMeta } from "/src/pages/news/search/[...slug].vue?macro=true";
import { default as p_91id_938CmBzn8tMWMeta } from "/src/pages/p[id].vue?macro=true";
import { default as _91token_935tXqSszXnOMeta } from "/src/pages/password/reset/[token].vue?macro=true";
import { default as indexnZjT320KxPMeta } from "/src/pages/password/reset/index.vue?macro=true";
import { default as builder_45cache_45burstDkoQ4bK017Meta } from "/src/pages/performance/builder-cache-burst.vue?macro=true";
import { default as datadog7e8k9ukhEHMeta } from "/src/pages/performance/datadog.vue?macro=true";
import { default as footerGuNnz8o9qHMeta } from "/src/pages/performance/footer.vue?macro=true";
import { default as header_45and_45footerzR4KKF9lYaMeta } from "/src/pages/performance/header-and-footer.vue?macro=true";
import { default as headerF1jsIvmvcJMeta } from "/src/pages/performance/header.vue?macro=true";
import { default as index2wY64w9TVcMeta } from "/src/pages/performance/index.vue?macro=true";
import { default as _91_46_46_46type_93D8rZke4cSXMeta } from "/src/pages/pro-card/application/[...type].vue?macro=true";
import { default as complete32CooXhP1OMeta } from "/src/pages/pro-card/application/complete.vue?macro=true";
import { default as processhuZehGfDOiMeta } from "/src/pages/pro-card/application/process.vue?macro=true";
import { default as protected9vIm5HjWboMeta } from "/src/pages/protected.vue?macro=true";
import { default as register9mc1FDQpDSMeta } from "/src/pages/register.vue?macro=true";
import { default as save_45list_45coder0arZo5el5Meta } from "/src/pages/save-list-code.vue?macro=true";
import { default as index6KfTDieHyuMeta } from "/src/pages/search/index.vue?macro=true";
import { default as sitemapiIks4zSRrbMeta } from "/src/pages/sitemap.vue?macro=true";
import { default as trolley_45codeIAikYRlR32Meta } from "/src/pages/trolley-code.vue?macro=true";
import { default as trolleyjtkPvpRsI0Meta } from "/src/pages/trolley.vue?macro=true";
import { default as under_45maintenanceJVbaQctFseMeta } from "/src/pages/under-maintenance.vue?macro=true";
import { default as component_45stubgxFpV4faLuMeta } from "/src/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stubgxFpV4faLu } from "/src/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "products-listing-slug___nl-NL___default",
    path: "/products-listing/:slug()",
    component: () => import("/src/pages/(section-models)/products-listing/[slug].vue")
  },
  {
    name: "products-listing-slug___nl-NL",
    path: "/nl-NL/products-listing/:slug()",
    component: () => import("/src/pages/(section-models)/products-listing/[slug].vue")
  },
  {
    name: "products-listing-slug___nl-BE",
    path: "/nl-BE/products-listing/:slug()",
    component: () => import("/src/pages/(section-models)/products-listing/[slug].vue")
  },
  {
    name: "ribbon-slug___nl-NL___default",
    path: "/ribbon/:slug()",
    component: () => import("/src/pages/(section-models)/ribbon/[slug].vue")
  },
  {
    name: "ribbon-slug___nl-NL",
    path: "/nl-NL/ribbon/:slug()",
    component: () => import("/src/pages/(section-models)/ribbon/[slug].vue")
  },
  {
    name: "ribbon-slug___nl-BE",
    path: "/nl-BE/ribbon/:slug()",
    component: () => import("/src/pages/(section-models)/ribbon/[slug].vue")
  },
  {
    name: "symbol-slug___nl-NL___default",
    path: "/symbol/:slug()",
    component: () => import("/src/pages/(section-models)/symbol/[slug].vue")
  },
  {
    name: "symbol-slug___nl-NL",
    path: "/nl-NL/symbol/:slug()",
    component: () => import("/src/pages/(section-models)/symbol/[slug].vue")
  },
  {
    name: "symbol-slug___nl-BE",
    path: "/nl-BE/symbol/:slug()",
    component: () => import("/src/pages/(section-models)/symbol/[slug].vue")
  },
  {
    name: "slug___nl-NL___default",
    path: "/:slug(.*)*",
    meta: _91_46_46_46slug_93ly9c2K2HsSMeta || {},
    component: () => import("/src/pages/[...slug].vue")
  },
  {
    name: "slug___nl-NL",
    path: "/nl-NL/:slug(.*)*",
    meta: _91_46_46_46slug_93ly9c2K2HsSMeta || {},
    component: () => import("/src/pages/[...slug].vue")
  },
  {
    name: "slug___nl-BE",
    path: "/nl-BE/:slug(.*)*",
    meta: _91_46_46_46slug_93ly9c2K2HsSMeta || {},
    component: () => import("/src/pages/[...slug].vue")
  },
  {
    name: "slug-childSlug-cid___nl-NL___default",
    path: "/:slug/:childSlug/c:id(\\d+)",
    meta: c_91id_939lfc6Lx5DfMeta || {},
    component: () => import("/src/pages/[slug]/[childSlug]/c[id].vue")
  },
  {
    name: "slug-childSlug-cid___nl-NL",
    path: "/nl-NL/:slug/:childSlug/c:id(\\d+)",
    meta: c_91id_939lfc6Lx5DfMeta || {},
    component: () => import("/src/pages/[slug]/[childSlug]/c[id].vue")
  },
  {
    name: "slug-childSlug-cid___nl-BE",
    path: "/nl-BE/:slug/:childSlug/c:id(\\d+)",
    meta: c_91id_939lfc6Lx5DfMeta || {},
    component: () => import("/src/pages/[slug]/[childSlug]/c[id].vue")
  },
  {
    name: "slug-cid___nl-NL___default",
    path: "/:slug/c:id(\\d+)",
    meta: c_91id_93rfOdXDR9I1Meta || {},
    component: () => import("/src/pages/[slug]/c[id].vue")
  },
  {
    name: "slug-cid___nl-NL",
    path: "/nl-NL/:slug/c:id(\\d+)",
    meta: c_91id_93rfOdXDR9I1Meta || {},
    component: () => import("/src/pages/[slug]/c[id].vue")
  },
  {
    name: "slug-cid___nl-BE",
    path: "/nl-BE/:slug/c:id(\\d+)",
    meta: c_91id_93rfOdXDR9I1Meta || {},
    component: () => import("/src/pages/[slug]/c[id].vue")
  },
  {
    name: "slug-pid___nl-NL___default",
    path: "/:slug/p:id(\\d+)",
    meta: p_91id_93sbrrAKGVMKMeta || {},
    component: () => import("/src/pages/[slug]/p[id].vue")
  },
  {
    name: "slug-pid___nl-NL",
    path: "/nl-NL/:slug/p:id(\\d+)",
    meta: p_91id_93sbrrAKGVMKMeta || {},
    component: () => import("/src/pages/[slug]/p[id].vue")
  },
  {
    name: "slug-pid___nl-BE",
    path: "/nl-BE/:slug/p:id(\\d+)",
    meta: p_91id_93sbrrAKGVMKMeta || {},
    component: () => import("/src/pages/[slug]/p[id].vue")
  },
  {
    name: "account-addresses___nl-NL___default",
    path: "/account/addresses",
    meta: addressesIGZCkwNaoqMeta || {},
    component: () => import("/src/pages/account/addresses.vue")
  },
  {
    name: "account-addresses___nl-NL",
    path: "/nl-NL/account/addresses",
    meta: addressesIGZCkwNaoqMeta || {},
    component: () => import("/src/pages/account/addresses.vue")
  },
  {
    name: "account-addresses___nl-BE",
    path: "/nl-BE/account/addresses",
    meta: addressesIGZCkwNaoqMeta || {},
    component: () => import("/src/pages/account/addresses.vue")
  },
  {
    name: "account-branch___nl-NL___default",
    path: "/account/branch",
    meta: branchLeelI7jTJ2Meta || {},
    component: () => import("/src/pages/account/branch.vue")
  },
  {
    name: "account-branch___nl-NL",
    path: "/nl-NL/account/branch",
    meta: branchLeelI7jTJ2Meta || {},
    component: () => import("/src/pages/account/branch.vue")
  },
  {
    name: "account-branch___nl-BE",
    path: "/nl-BE/account/branch",
    meta: branchLeelI7jTJ2Meta || {},
    component: () => import("/src/pages/account/branch.vue")
  },
  {
    name: "account-home___nl-NL___default",
    path: "/account/home",
    meta: homewOlFek1DsrMeta || {},
    component: () => import("/src/pages/account/home.vue")
  },
  {
    name: "account-home___nl-NL",
    path: "/nl-NL/account/home",
    meta: homewOlFek1DsrMeta || {},
    component: () => import("/src/pages/account/home.vue")
  },
  {
    name: "account-home___nl-BE",
    path: "/nl-BE/account/home",
    meta: homewOlFek1DsrMeta || {},
    component: () => import("/src/pages/account/home.vue")
  },
  {
    name: "account-message___nl-NL___default",
    path: "/account/message",
    meta: indexooyXi1B20PMeta || {},
    component: () => import("/src/pages/account/message/index.vue")
  },
  {
    name: "account-message___nl-NL",
    path: "/nl-NL/account/message",
    meta: indexooyXi1B20PMeta || {},
    component: () => import("/src/pages/account/message/index.vue")
  },
  {
    name: "account-message___nl-BE",
    path: "/nl-BE/account/message",
    meta: indexooyXi1B20PMeta || {},
    component: () => import("/src/pages/account/message/index.vue")
  },
  {
    name: "account-order-again___nl-NL___default",
    path: "/account/order-again",
    meta: order_45againAl94P4iRtrMeta || {},
    component: () => import("/src/pages/account/order-again.vue")
  },
  {
    name: "account-order-again___nl-NL",
    path: "/nl-NL/account/order-again",
    meta: order_45againAl94P4iRtrMeta || {},
    component: () => import("/src/pages/account/order-again.vue")
  },
  {
    name: "account-order-again___nl-BE",
    path: "/nl-BE/account/order-again",
    meta: order_45againAl94P4iRtrMeta || {},
    component: () => import("/src/pages/account/order-again.vue")
  },
  {
    name: "account-order-history___nl-NL___default",
    path: "/account/order-history",
    meta: indexU0lkcgg280Meta || {},
    component: () => import("/src/pages/account/order-history/index.vue")
  },
  {
    name: "account-order-history___nl-NL",
    path: "/nl-NL/account/order-history",
    meta: indexU0lkcgg280Meta || {},
    component: () => import("/src/pages/account/order-history/index.vue")
  },
  {
    name: "account-order-history___nl-BE",
    path: "/nl-BE/account/order-history",
    meta: indexU0lkcgg280Meta || {},
    component: () => import("/src/pages/account/order-history/index.vue")
  },
  {
    name: "account-order-history-product-review-slug___nl-NL___default",
    path: "/account/order-history/product-review/:slug(\\d+)",
    meta: _91slug_93iFCusQg9rAMeta || {},
    component: () => import("/src/pages/account/order-history/product-review/[slug].vue")
  },
  {
    name: "account-order-history-product-review-slug___nl-NL",
    path: "/nl-NL/account/order-history/product-review/:slug(\\d+)",
    meta: _91slug_93iFCusQg9rAMeta || {},
    component: () => import("/src/pages/account/order-history/product-review/[slug].vue")
  },
  {
    name: "account-order-history-product-review-slug___nl-BE",
    path: "/nl-BE/account/order-history/product-review/:slug(\\d+)",
    meta: _91slug_93iFCusQg9rAMeta || {},
    component: () => import("/src/pages/account/order-history/product-review/[slug].vue")
  },
  {
    name: "account-preferences___nl-NL___default",
    path: "/account/preferences",
    meta: preferencesdJ2KFlTg2IMeta || {},
    component: () => import("/src/pages/account/preferences.vue")
  },
  {
    name: "account-preferences___nl-NL",
    path: "/nl-NL/account/preferences",
    meta: preferencesdJ2KFlTg2IMeta || {},
    component: () => import("/src/pages/account/preferences.vue")
  },
  {
    name: "account-preferences___nl-BE",
    path: "/nl-BE/account/preferences",
    meta: preferencesdJ2KFlTg2IMeta || {},
    component: () => import("/src/pages/account/preferences.vue")
  },
  {
    name: "account-pro-card-credit-limit___nl-NL___default",
    path: "/account/pro-card/credit-limit",
    meta: credit_45limitU3cA6y74U5Meta || {},
    component: () => import("/src/pages/account/pro-card/credit-limit.vue")
  },
  {
    name: "account-pro-card-credit-limit___nl-NL",
    path: "/nl-NL/account/pro-card/credit-limit",
    meta: credit_45limitU3cA6y74U5Meta || {},
    component: () => import("/src/pages/account/pro-card/credit-limit.vue")
  },
  {
    name: "account-pro-card-credit-limit___nl-BE",
    path: "/nl-BE/account/pro-card/credit-limit",
    meta: credit_45limitU3cA6y74U5Meta || {},
    component: () => import("/src/pages/account/pro-card/credit-limit.vue")
  },
  {
    name: "account-pro-card___nl-NL___default",
    path: "/account/pro-card",
    meta: indexNPNSvaNcoVMeta || {},
    component: () => import("/src/pages/account/pro-card/index.vue")
  },
  {
    name: "account-pro-card___nl-NL",
    path: "/nl-NL/account/pro-card",
    meta: indexNPNSvaNcoVMeta || {},
    component: () => import("/src/pages/account/pro-card/index.vue")
  },
  {
    name: "account-pro-card___nl-BE",
    path: "/nl-BE/account/pro-card",
    meta: indexNPNSvaNcoVMeta || {},
    component: () => import("/src/pages/account/pro-card/index.vue")
  },
  {
    name: "account-pro-card-orders___nl-NL___default",
    path: "/account/pro-card/orders",
    meta: ordersszUGksC2AFMeta || {},
    component: () => import("/src/pages/account/pro-card/orders.vue")
  },
  {
    name: "account-pro-card-orders___nl-NL",
    path: "/nl-NL/account/pro-card/orders",
    meta: ordersszUGksC2AFMeta || {},
    component: () => import("/src/pages/account/pro-card/orders.vue")
  },
  {
    name: "account-pro-card-orders___nl-BE",
    path: "/nl-BE/account/pro-card/orders",
    meta: ordersszUGksC2AFMeta || {},
    component: () => import("/src/pages/account/pro-card/orders.vue")
  },
  {
    name: "account-profile___nl-NL___default",
    path: "/account/profile",
    meta: profile4xkbZgafKZMeta || {},
    component: () => import("/src/pages/account/profile.vue")
  },
  {
    name: "account-profile___nl-NL",
    path: "/nl-NL/account/profile",
    meta: profile4xkbZgafKZMeta || {},
    component: () => import("/src/pages/account/profile.vue")
  },
  {
    name: "account-profile___nl-BE",
    path: "/nl-BE/account/profile",
    meta: profile4xkbZgafKZMeta || {},
    component: () => import("/src/pages/account/profile.vue")
  },
  {
    name: "account-saved-lists___nl-NL___default",
    path: "/account/saved-lists",
    meta: saved_45listszdd9554BNSMeta || {},
    component: () => import("/src/pages/account/saved-lists.vue")
  },
  {
    name: "account-saved-lists___nl-NL",
    path: "/nl-NL/account/saved-lists",
    meta: saved_45listszdd9554BNSMeta || {},
    component: () => import("/src/pages/account/saved-lists.vue")
  },
  {
    name: "account-saved-lists___nl-BE",
    path: "/nl-BE/account/saved-lists",
    meta: saved_45listszdd9554BNSMeta || {},
    component: () => import("/src/pages/account/saved-lists.vue")
  },
  {
    name: "account-stock-notification___nl-NL___default",
    path: "/account/stock-notification",
    meta: stock_45notificationXbeAeLQuTaMeta || {},
    component: () => import("/src/pages/account/stock-notification.vue")
  },
  {
    name: "account-stock-notification___nl-NL",
    path: "/nl-NL/account/stock-notification",
    meta: stock_45notificationXbeAeLQuTaMeta || {},
    component: () => import("/src/pages/account/stock-notification.vue")
  },
  {
    name: "account-stock-notification___nl-BE",
    path: "/nl-BE/account/stock-notification",
    meta: stock_45notificationXbeAeLQuTaMeta || {},
    component: () => import("/src/pages/account/stock-notification.vue")
  },
  {
    name: "advices-slug___nl-NL___default",
    path: "/advices/:slug(.*)*",
    component: () => import("/src/pages/advices/[...slug].vue")
  },
  {
    name: "advices-slug___nl-NL",
    path: "/nl-NL/advices/:slug(.*)*",
    component: () => import("/src/pages/advices/[...slug].vue")
  },
  {
    name: "advices-slug___nl-BE",
    path: "/nl-BE/advices/:slug(.*)*",
    component: () => import("/src/pages/advices/[...slug].vue")
  },
  {
    name: "advices___nl-NL___default",
    path: "/advices",
    component: () => import("/src/pages/advices/index.vue")
  },
  {
    name: "advices___nl-NL",
    path: "/nl-NL/advices",
    component: () => import("/src/pages/advices/index.vue")
  },
  {
    name: "advices___nl-BE",
    path: "/nl-BE/advices",
    component: () => import("/src/pages/advices/index.vue")
  },
  {
    name: "advices-search-slug___nl-NL___default",
    path: "/advices/search/:slug(.*)*",
    component: () => import("/src/pages/advices/search/[...slug].vue")
  },
  {
    name: "advices-search-slug___nl-NL",
    path: "/nl-NL/advices/search/:slug(.*)*",
    component: () => import("/src/pages/advices/search/[...slug].vue")
  },
  {
    name: "advices-search-slug___nl-BE",
    path: "/nl-BE/advices/search/:slug(.*)*",
    component: () => import("/src/pages/advices/search/[...slug].vue")
  },
  {
    name: "blogs-news-advices___nl-NL___default",
    path: "/blogs-news-advices",
    component: () => import("/src/pages/blogs-news-advices/index.vue")
  },
  {
    name: "blogs-news-advices___nl-NL",
    path: "/nl-NL/blogs-news-advices",
    component: () => import("/src/pages/blogs-news-advices/index.vue")
  },
  {
    name: "blogs-news-advices___nl-BE",
    path: "/nl-BE/blogs-news-advices",
    component: () => import("/src/pages/blogs-news-advices/index.vue")
  },
  {
    name: "blogs-slug___nl-NL___default",
    path: "/blogs/:slug(.*)*",
    component: () => import("/src/pages/blogs/[...slug].vue")
  },
  {
    name: "blogs-slug___nl-NL",
    path: "/nl-NL/blogs/:slug(.*)*",
    component: () => import("/src/pages/blogs/[...slug].vue")
  },
  {
    name: "blogs-slug___nl-BE",
    path: "/nl-BE/blogs/:slug(.*)*",
    component: () => import("/src/pages/blogs/[...slug].vue")
  },
  {
    name: "blogs___nl-NL___default",
    path: "/blogs",
    component: () => import("/src/pages/blogs/index.vue")
  },
  {
    name: "blogs___nl-NL",
    path: "/nl-NL/blogs",
    component: () => import("/src/pages/blogs/index.vue")
  },
  {
    name: "blogs___nl-BE",
    path: "/nl-BE/blogs",
    component: () => import("/src/pages/blogs/index.vue")
  },
  {
    name: "blogs-search-slug___nl-NL___default",
    path: "/blogs/search/:slug(.*)*",
    component: () => import("/src/pages/blogs/search/[...slug].vue")
  },
  {
    name: "blogs-search-slug___nl-NL",
    path: "/nl-NL/blogs/search/:slug(.*)*",
    component: () => import("/src/pages/blogs/search/[...slug].vue")
  },
  {
    name: "blogs-search-slug___nl-BE",
    path: "/nl-BE/blogs/search/:slug(.*)*",
    component: () => import("/src/pages/blogs/search/[...slug].vue")
  },
  {
    name: "branches-slug___nl-NL___default",
    path: "/branches/:slug()",
    component: () => import("/src/pages/branches/[slug].vue")
  },
  {
    name: "branches-slug___nl-NL",
    path: "/nl-NL/branches/:slug()",
    component: () => import("/src/pages/branches/[slug].vue")
  },
  {
    name: "branches-slug___nl-BE",
    path: "/nl-BE/branches/:slug()",
    component: () => import("/src/pages/branches/[slug].vue")
  },
  {
    name: "branches___nl-NL___default",
    path: "/branches",
    component: () => import("/src/pages/branches/index.vue")
  },
  {
    name: "branches___nl-NL",
    path: "/nl-NL/branches",
    component: () => import("/src/pages/branches/index.vue")
  },
  {
    name: "branches___nl-BE",
    path: "/nl-BE/branches",
    component: () => import("/src/pages/branches/index.vue")
  },
  {
    name: "buy-now___nl-NL___default",
    path: "/buy-now",
    meta: indexTs0s2nd2ddMeta || {},
    component: () => import("/src/pages/buy-now/index.vue")
  },
  {
    name: "buy-now___nl-NL",
    path: "/nl-NL/buy-now",
    meta: indexTs0s2nd2ddMeta || {},
    component: () => import("/src/pages/buy-now/index.vue")
  },
  {
    name: "buy-now___nl-BE",
    path: "/nl-BE/buy-now",
    meta: indexTs0s2nd2ddMeta || {},
    component: () => import("/src/pages/buy-now/index.vue")
  },
  {
    name: "categories___nl-NL___default",
    path: "/categories",
    component: () => import("/src/pages/categories/index.vue")
  },
  {
    name: "categories___nl-NL",
    path: "/nl-NL/categories",
    component: () => import("/src/pages/categories/index.vue")
  },
  {
    name: "categories___nl-BE",
    path: "/nl-BE/categories",
    component: () => import("/src/pages/categories/index.vue")
  },
  {
    name: "checkout-fallback___nl-NL___default",
    path: "/checkout/fallback",
    meta: fallbackxkdwHKBZ1gMeta || {},
    component: () => import("/src/pages/checkout/fallback.vue")
  },
  {
    name: "checkout-fallback___nl-NL",
    path: "/nl-NL/checkout/fallback",
    meta: fallbackxkdwHKBZ1gMeta || {},
    component: () => import("/src/pages/checkout/fallback.vue")
  },
  {
    name: "checkout-fallback___nl-BE",
    path: "/nl-BE/checkout/fallback",
    meta: fallbackxkdwHKBZ1gMeta || {},
    component: () => import("/src/pages/checkout/fallback.vue")
  },
  {
    name: "checkout___nl-NL___default",
    path: "/checkout",
    meta: index4E3N5yzW7cMeta || {},
    component: () => import("/src/pages/checkout/index.vue")
  },
  {
    name: "checkout___nl-NL",
    path: "/nl-NL/checkout",
    meta: index4E3N5yzW7cMeta || {},
    component: () => import("/src/pages/checkout/index.vue")
  },
  {
    name: "checkout___nl-BE",
    path: "/nl-BE/checkout",
    meta: index4E3N5yzW7cMeta || {},
    component: () => import("/src/pages/checkout/index.vue")
  },
  {
    name: "checkout-order-confirmation-slug___nl-NL___default",
    path: "/checkout/order-confirmation/:slug()",
    meta: _91slug_93fTREvo4l4pMeta || {},
    component: () => import("/src/pages/checkout/order-confirmation/[slug].vue")
  },
  {
    name: "checkout-order-confirmation-slug___nl-NL",
    path: "/nl-NL/checkout/order-confirmation/:slug()",
    meta: _91slug_93fTREvo4l4pMeta || {},
    component: () => import("/src/pages/checkout/order-confirmation/[slug].vue")
  },
  {
    name: "checkout-order-confirmation-slug___nl-BE",
    path: "/nl-BE/checkout/order-confirmation/:slug()",
    meta: _91slug_93fTREvo4l4pMeta || {},
    component: () => import("/src/pages/checkout/order-confirmation/[slug].vue")
  },
  {
    name: "content-slug___nl-NL___default",
    path: "/content/:slug(.*)*",
    meta: _91_46_46_46slug_93cyGcYUJqP3Meta || {},
    component: () => import("/src/pages/content/[...slug].vue")
  },
  {
    name: "content-slug___nl-NL",
    path: "/nl-NL/content/:slug(.*)*",
    meta: _91_46_46_46slug_93cyGcYUJqP3Meta || {},
    component: () => import("/src/pages/content/[...slug].vue")
  },
  {
    name: "content-slug___nl-BE",
    path: "/nl-BE/content/:slug(.*)*",
    meta: _91_46_46_46slug_93cyGcYUJqP3Meta || {},
    component: () => import("/src/pages/content/[...slug].vue")
  },
  {
    name: "events-slug___nl-NL___default",
    path: "/events/:slug(.*)*",
    meta: _91_46_46_46slug_93c99CfJteH1Meta || {},
    component: () => import("/src/pages/events/[...slug].vue")
  },
  {
    name: "events-slug___nl-NL",
    path: "/nl-NL/events/:slug(.*)*",
    meta: _91_46_46_46slug_93c99CfJteH1Meta || {},
    component: () => import("/src/pages/events/[...slug].vue")
  },
  {
    name: "events-slug___nl-BE",
    path: "/nl-BE/events/:slug(.*)*",
    meta: _91_46_46_46slug_93c99CfJteH1Meta || {},
    component: () => import("/src/pages/events/[...slug].vue")
  },
  {
    name: "events___nl-NL___default",
    path: "/events",
    component: () => import("/src/pages/events/index.vue")
  },
  {
    name: "events___nl-NL",
    path: "/nl-NL/events",
    component: () => import("/src/pages/events/index.vue")
  },
  {
    name: "events___nl-BE",
    path: "/nl-BE/events",
    component: () => import("/src/pages/events/index.vue")
  },
  {
    name: "events-offline-slug___nl-NL___default",
    path: "/events/offline/:slug(.*)*",
    component: () => import("/src/pages/events/offline/[...slug].vue")
  },
  {
    name: "events-offline-slug___nl-NL",
    path: "/nl-NL/events/offline/:slug(.*)*",
    component: () => import("/src/pages/events/offline/[...slug].vue")
  },
  {
    name: "events-offline-slug___nl-BE",
    path: "/nl-BE/events/offline/:slug(.*)*",
    component: () => import("/src/pages/events/offline/[...slug].vue")
  },
  {
    name: "events-offline___nl-NL___default",
    path: "/events/offline",
    component: () => import("/src/pages/events/offline/index.vue")
  },
  {
    name: "events-offline___nl-NL",
    path: "/nl-NL/events/offline",
    component: () => import("/src/pages/events/offline/index.vue")
  },
  {
    name: "events-offline___nl-BE",
    path: "/nl-BE/events/offline",
    component: () => import("/src/pages/events/offline/index.vue")
  },
  {
    name: "events-online-slug___nl-NL___default",
    path: "/events/online/:slug(.*)*",
    component: () => import("/src/pages/events/online/[...slug].vue")
  },
  {
    name: "events-online-slug___nl-NL",
    path: "/nl-NL/events/online/:slug(.*)*",
    component: () => import("/src/pages/events/online/[...slug].vue")
  },
  {
    name: "events-online-slug___nl-BE",
    path: "/nl-BE/events/online/:slug(.*)*",
    component: () => import("/src/pages/events/online/[...slug].vue")
  },
  {
    name: "events-online___nl-NL___default",
    path: "/events/online",
    component: () => import("/src/pages/events/online/index.vue")
  },
  {
    name: "events-online___nl-NL",
    path: "/nl-NL/events/online",
    component: () => import("/src/pages/events/online/index.vue")
  },
  {
    name: "events-online___nl-BE",
    path: "/nl-BE/events/online",
    component: () => import("/src/pages/events/online/index.vue")
  },
  {
    name: "index___nl-NL___default",
    path: "/",
    component: () => import("/src/pages/index.vue")
  },
  {
    name: "index___nl-NL",
    path: "/nl-NL",
    component: () => import("/src/pages/index.vue")
  },
  {
    name: "index___nl-BE",
    path: "/nl-BE",
    component: () => import("/src/pages/index.vue")
  },
  {
    name: "login___nl-NL___default",
    path: "/login",
    meta: loginTLBFe6DICLMeta || {},
    component: () => import("/src/pages/login.vue")
  },
  {
    name: "login___nl-NL",
    path: "/nl-NL/login",
    meta: loginTLBFe6DICLMeta || {},
    component: () => import("/src/pages/login.vue")
  },
  {
    name: "login___nl-BE",
    path: "/nl-BE/login",
    meta: loginTLBFe6DICLMeta || {},
    component: () => import("/src/pages/login.vue")
  },
  {
    name: "merk-brandName-deals___nl-NL___default",
    path: "/merk/:brandName()/deals",
    meta: dealso75S7JgVGcMeta || {},
    component: () => import("/src/pages/merk/[brandName]/deals.vue")
  },
  {
    name: "merk-brandName-deals___nl-NL",
    path: "/nl-NL/merk/:brandName()/deals",
    meta: dealso75S7JgVGcMeta || {},
    component: () => import("/src/pages/merk/[brandName]/deals.vue")
  },
  {
    name: "merk-brandName-deals___nl-BE",
    path: "/nl-BE/merk/:brandName()/deals",
    meta: dealso75S7JgVGcMeta || {},
    component: () => import("/src/pages/merk/[brandName]/deals.vue")
  },
  {
    name: "merk-brandName___nl-NL___default",
    path: "/merk/:brandName()",
    meta: indexyGz7q34VsOMeta || {},
    component: () => import("/src/pages/merk/[brandName]/index.vue")
  },
  {
    name: "merk-brandName___nl-NL",
    path: "/nl-NL/merk/:brandName()",
    meta: indexyGz7q34VsOMeta || {},
    component: () => import("/src/pages/merk/[brandName]/index.vue")
  },
  {
    name: "merk-brandName___nl-BE",
    path: "/nl-BE/merk/:brandName()",
    meta: indexyGz7q34VsOMeta || {},
    component: () => import("/src/pages/merk/[brandName]/index.vue")
  },
  {
    name: "merk-brandName-products___nl-NL___default",
    path: "/merk/:brandName()/products",
    meta: productsD4rnmw1ybqMeta || {},
    component: () => import("/src/pages/merk/[brandName]/products.vue")
  },
  {
    name: "merk-brandName-products___nl-NL",
    path: "/nl-NL/merk/:brandName()/products",
    meta: productsD4rnmw1ybqMeta || {},
    component: () => import("/src/pages/merk/[brandName]/products.vue")
  },
  {
    name: "merk-brandName-products___nl-BE",
    path: "/nl-BE/merk/:brandName()/products",
    meta: productsD4rnmw1ybqMeta || {},
    component: () => import("/src/pages/merk/[brandName]/products.vue")
  },
  {
    name: "merk___nl-NL___default",
    path: "/merk",
    component: () => import("/src/pages/merk/index.vue")
  },
  {
    name: "merk___nl-NL",
    path: "/nl-NL/merk",
    component: () => import("/src/pages/merk/index.vue")
  },
  {
    name: "merk___nl-BE",
    path: "/nl-BE/merk",
    component: () => import("/src/pages/merk/index.vue")
  },
  {
    name: "news-slug___nl-NL___default",
    path: "/news/:slug(.*)*",
    component: () => import("/src/pages/news/[...slug].vue")
  },
  {
    name: "news-slug___nl-NL",
    path: "/nl-NL/news/:slug(.*)*",
    component: () => import("/src/pages/news/[...slug].vue")
  },
  {
    name: "news-slug___nl-BE",
    path: "/nl-BE/news/:slug(.*)*",
    component: () => import("/src/pages/news/[...slug].vue")
  },
  {
    name: "news___nl-NL___default",
    path: "/news",
    component: () => import("/src/pages/news/index.vue")
  },
  {
    name: "news___nl-NL",
    path: "/nl-NL/news",
    component: () => import("/src/pages/news/index.vue")
  },
  {
    name: "news___nl-BE",
    path: "/nl-BE/news",
    component: () => import("/src/pages/news/index.vue")
  },
  {
    name: "news-search-slug___nl-NL___default",
    path: "/news/search/:slug(.*)*",
    component: () => import("/src/pages/news/search/[...slug].vue")
  },
  {
    name: "news-search-slug___nl-NL",
    path: "/nl-NL/news/search/:slug(.*)*",
    component: () => import("/src/pages/news/search/[...slug].vue")
  },
  {
    name: "news-search-slug___nl-BE",
    path: "/nl-BE/news/search/:slug(.*)*",
    component: () => import("/src/pages/news/search/[...slug].vue")
  },
  {
    name: "pid___nl-NL___default",
    path: "/p:id(\\d+)",
    meta: p_91id_938CmBzn8tMWMeta || {},
    component: () => import("/src/pages/p[id].vue")
  },
  {
    name: "pid___nl-NL",
    path: "/nl-NL/p:id(\\d+)",
    meta: p_91id_938CmBzn8tMWMeta || {},
    component: () => import("/src/pages/p[id].vue")
  },
  {
    name: "pid___nl-BE",
    path: "/nl-BE/p:id(\\d+)",
    meta: p_91id_938CmBzn8tMWMeta || {},
    component: () => import("/src/pages/p[id].vue")
  },
  {
    name: "password-reset-token___nl-NL___default",
    path: "/password/reset/:token()",
    meta: _91token_935tXqSszXnOMeta || {},
    component: () => import("/src/pages/password/reset/[token].vue")
  },
  {
    name: "password-reset-token___nl-NL",
    path: "/nl-NL/password/reset/:token()",
    meta: _91token_935tXqSszXnOMeta || {},
    component: () => import("/src/pages/password/reset/[token].vue")
  },
  {
    name: "password-reset-token___nl-BE",
    path: "/nl-BE/password/reset/:token()",
    meta: _91token_935tXqSszXnOMeta || {},
    component: () => import("/src/pages/password/reset/[token].vue")
  },
  {
    name: "password-reset___nl-NL___default",
    path: "/password/reset",
    meta: indexnZjT320KxPMeta || {},
    component: () => import("/src/pages/password/reset/index.vue")
  },
  {
    name: "password-reset___nl-NL",
    path: "/nl-NL/password/reset",
    meta: indexnZjT320KxPMeta || {},
    component: () => import("/src/pages/password/reset/index.vue")
  },
  {
    name: "password-reset___nl-BE",
    path: "/nl-BE/password/reset",
    meta: indexnZjT320KxPMeta || {},
    component: () => import("/src/pages/password/reset/index.vue")
  },
  {
    name: "performance-builder-cache-burst___nl-NL___default",
    path: "/performance/builder-cache-burst",
    meta: builder_45cache_45burstDkoQ4bK017Meta || {},
    component: () => import("/src/pages/performance/builder-cache-burst.vue")
  },
  {
    name: "performance-builder-cache-burst___nl-NL",
    path: "/nl-NL/performance/builder-cache-burst",
    meta: builder_45cache_45burstDkoQ4bK017Meta || {},
    component: () => import("/src/pages/performance/builder-cache-burst.vue")
  },
  {
    name: "performance-builder-cache-burst___nl-BE",
    path: "/nl-BE/performance/builder-cache-burst",
    meta: builder_45cache_45burstDkoQ4bK017Meta || {},
    component: () => import("/src/pages/performance/builder-cache-burst.vue")
  },
  {
    name: "performance-datadog___nl-NL___default",
    path: "/performance/datadog",
    meta: datadog7e8k9ukhEHMeta || {},
    component: () => import("/src/pages/performance/datadog.vue")
  },
  {
    name: "performance-datadog___nl-NL",
    path: "/nl-NL/performance/datadog",
    meta: datadog7e8k9ukhEHMeta || {},
    component: () => import("/src/pages/performance/datadog.vue")
  },
  {
    name: "performance-datadog___nl-BE",
    path: "/nl-BE/performance/datadog",
    meta: datadog7e8k9ukhEHMeta || {},
    component: () => import("/src/pages/performance/datadog.vue")
  },
  {
    name: "performance-footer___nl-NL___default",
    path: "/performance/footer",
    meta: footerGuNnz8o9qHMeta || {},
    component: () => import("/src/pages/performance/footer.vue")
  },
  {
    name: "performance-footer___nl-NL",
    path: "/nl-NL/performance/footer",
    meta: footerGuNnz8o9qHMeta || {},
    component: () => import("/src/pages/performance/footer.vue")
  },
  {
    name: "performance-footer___nl-BE",
    path: "/nl-BE/performance/footer",
    meta: footerGuNnz8o9qHMeta || {},
    component: () => import("/src/pages/performance/footer.vue")
  },
  {
    name: "performance-header-and-footer___nl-NL___default",
    path: "/performance/header-and-footer",
    meta: header_45and_45footerzR4KKF9lYaMeta || {},
    component: () => import("/src/pages/performance/header-and-footer.vue")
  },
  {
    name: "performance-header-and-footer___nl-NL",
    path: "/nl-NL/performance/header-and-footer",
    meta: header_45and_45footerzR4KKF9lYaMeta || {},
    component: () => import("/src/pages/performance/header-and-footer.vue")
  },
  {
    name: "performance-header-and-footer___nl-BE",
    path: "/nl-BE/performance/header-and-footer",
    meta: header_45and_45footerzR4KKF9lYaMeta || {},
    component: () => import("/src/pages/performance/header-and-footer.vue")
  },
  {
    name: "performance-header___nl-NL___default",
    path: "/performance/header",
    meta: headerF1jsIvmvcJMeta || {},
    component: () => import("/src/pages/performance/header.vue")
  },
  {
    name: "performance-header___nl-NL",
    path: "/nl-NL/performance/header",
    meta: headerF1jsIvmvcJMeta || {},
    component: () => import("/src/pages/performance/header.vue")
  },
  {
    name: "performance-header___nl-BE",
    path: "/nl-BE/performance/header",
    meta: headerF1jsIvmvcJMeta || {},
    component: () => import("/src/pages/performance/header.vue")
  },
  {
    name: "performance___nl-NL___default",
    path: "/performance",
    meta: index2wY64w9TVcMeta || {},
    component: () => import("/src/pages/performance/index.vue")
  },
  {
    name: "performance___nl-NL",
    path: "/nl-NL/performance",
    meta: index2wY64w9TVcMeta || {},
    component: () => import("/src/pages/performance/index.vue")
  },
  {
    name: "performance___nl-BE",
    path: "/nl-BE/performance",
    meta: index2wY64w9TVcMeta || {},
    component: () => import("/src/pages/performance/index.vue")
  },
  {
    name: "pro-card-application-type___nl-NL___default",
    path: "/pro-card/application/:type(.*)*",
    meta: _91_46_46_46type_93D8rZke4cSXMeta || {},
    component: () => import("/src/pages/pro-card/application/[...type].vue")
  },
  {
    name: "pro-card-application-type___nl-NL",
    path: "/nl-NL/pro-card/application/:type(.*)*",
    meta: _91_46_46_46type_93D8rZke4cSXMeta || {},
    component: () => import("/src/pages/pro-card/application/[...type].vue")
  },
  {
    name: "pro-card-application-type___nl-BE",
    path: "/nl-BE/pro-card/application/:type(.*)*",
    meta: _91_46_46_46type_93D8rZke4cSXMeta || {},
    component: () => import("/src/pages/pro-card/application/[...type].vue")
  },
  {
    name: "pro-card-application-complete___nl-NL___default",
    path: "/pro-card/application/complete",
    meta: complete32CooXhP1OMeta || {},
    component: () => import("/src/pages/pro-card/application/complete.vue")
  },
  {
    name: "pro-card-application-complete___nl-NL",
    path: "/nl-NL/pro-card/application/complete",
    meta: complete32CooXhP1OMeta || {},
    component: () => import("/src/pages/pro-card/application/complete.vue")
  },
  {
    name: "pro-card-application-complete___nl-BE",
    path: "/nl-BE/pro-card/application/complete",
    meta: complete32CooXhP1OMeta || {},
    component: () => import("/src/pages/pro-card/application/complete.vue")
  },
  {
    name: "pro-card-application-process___nl-NL___default",
    path: "/pro-card/application/process",
    meta: processhuZehGfDOiMeta || {},
    component: () => import("/src/pages/pro-card/application/process.vue")
  },
  {
    name: "pro-card-application-process___nl-NL",
    path: "/nl-NL/pro-card/application/process",
    meta: processhuZehGfDOiMeta || {},
    component: () => import("/src/pages/pro-card/application/process.vue")
  },
  {
    name: "pro-card-application-process___nl-BE",
    path: "/nl-BE/pro-card/application/process",
    meta: processhuZehGfDOiMeta || {},
    component: () => import("/src/pages/pro-card/application/process.vue")
  },
  {
    name: "protected___nl-NL___default",
    path: "/protected",
    meta: protected9vIm5HjWboMeta || {},
    component: () => import("/src/pages/protected.vue")
  },
  {
    name: "protected___nl-NL",
    path: "/nl-NL/protected",
    meta: protected9vIm5HjWboMeta || {},
    component: () => import("/src/pages/protected.vue")
  },
  {
    name: "protected___nl-BE",
    path: "/nl-BE/protected",
    meta: protected9vIm5HjWboMeta || {},
    component: () => import("/src/pages/protected.vue")
  },
  {
    name: "register___nl-NL___default",
    path: "/register",
    meta: register9mc1FDQpDSMeta || {},
    component: () => import("/src/pages/register.vue")
  },
  {
    name: "register___nl-NL",
    path: "/nl-NL/register",
    meta: register9mc1FDQpDSMeta || {},
    component: () => import("/src/pages/register.vue")
  },
  {
    name: "register___nl-BE",
    path: "/nl-BE/register",
    meta: register9mc1FDQpDSMeta || {},
    component: () => import("/src/pages/register.vue")
  },
  {
    name: "save-list-code___nl-NL___default",
    path: "/save-list-code",
    component: () => import("/src/pages/save-list-code.vue")
  },
  {
    name: "save-list-code___nl-NL",
    path: "/nl-NL/save-list-code",
    component: () => import("/src/pages/save-list-code.vue")
  },
  {
    name: "save-list-code___nl-BE",
    path: "/nl-BE/save-list-code",
    component: () => import("/src/pages/save-list-code.vue")
  },
  {
    name: "search___nl-NL___default",
    path: "/search",
    component: () => import("/src/pages/search/index.vue")
  },
  {
    name: "search___nl-NL",
    path: "/nl-NL/search",
    component: () => import("/src/pages/search/index.vue")
  },
  {
    name: "search___nl-BE",
    path: "/nl-BE/search",
    component: () => import("/src/pages/search/index.vue")
  },
  {
    name: "sitemap___nl-NL___default",
    path: "/sitemap",
    component: () => import("/src/pages/sitemap.vue")
  },
  {
    name: "sitemap___nl-NL",
    path: "/nl-NL/sitemap",
    component: () => import("/src/pages/sitemap.vue")
  },
  {
    name: "sitemap___nl-BE",
    path: "/nl-BE/sitemap",
    component: () => import("/src/pages/sitemap.vue")
  },
  {
    name: "trolley-code___nl-NL___default",
    path: "/trolley-code",
    component: () => import("/src/pages/trolley-code.vue")
  },
  {
    name: "trolley-code___nl-NL",
    path: "/nl-NL/trolley-code",
    component: () => import("/src/pages/trolley-code.vue")
  },
  {
    name: "trolley-code___nl-BE",
    path: "/nl-BE/trolley-code",
    component: () => import("/src/pages/trolley-code.vue")
  },
  {
    name: "trolley___nl-NL___default",
    path: "/trolley",
    component: () => import("/src/pages/trolley.vue")
  },
  {
    name: "trolley___nl-NL",
    path: "/nl-NL/trolley",
    component: () => import("/src/pages/trolley.vue")
  },
  {
    name: "trolley___nl-BE",
    path: "/nl-BE/trolley",
    component: () => import("/src/pages/trolley.vue")
  },
  {
    name: "under-maintenance___nl-NL___default",
    path: "/under-maintenance",
    meta: under_45maintenanceJVbaQctFseMeta || {},
    component: () => import("/src/pages/under-maintenance.vue")
  },
  {
    name: "under-maintenance___nl-NL",
    path: "/nl-NL/under-maintenance",
    meta: under_45maintenanceJVbaQctFseMeta || {},
    component: () => import("/src/pages/under-maintenance.vue")
  },
  {
    name: "under-maintenance___nl-BE",
    path: "/nl-BE/under-maintenance",
    meta: under_45maintenanceJVbaQctFseMeta || {},
    component: () => import("/src/pages/under-maintenance.vue")
  },
  {
    name: component_45stubgxFpV4faLuMeta?.name,
    path: "/account",
    component: component_45stubgxFpV4faLu
  },
  {
    name: component_45stubgxFpV4faLuMeta?.name,
    path: "/pro-card",
    component: component_45stubgxFpV4faLu
  },
  {
    name: component_45stubgxFpV4faLuMeta?.name,
    path: "/content/contact",
    component: component_45stubgxFpV4faLu
  },
  {
    name: component_45stubgxFpV4faLuMeta?.name,
    path: "/content/dewalt",
    component: component_45stubgxFpV4faLu
  },
  {
    name: component_45stubgxFpV4faLuMeta?.name,
    path: "/content/bosch",
    component: component_45stubgxFpV4faLu
  },
  {
    name: component_45stubgxFpV4faLuMeta?.name,
    path: "/content/einhell",
    component: component_45stubgxFpV4faLu
  },
  {
    name: component_45stubgxFpV4faLuMeta?.name,
    path: "/content/toughbuilt",
    component: component_45stubgxFpV4faLu
  },
  {
    name: component_45stubgxFpV4faLuMeta?.name,
    path: "/documents/myaccount_history",
    component: component_45stubgxFpV4faLu
  }
]